import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  .overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: .5s ease;
    background: #002DC2CC;
    backdrop-filter: blur(15px);
    border-radius: 9px;
    padding: auto;
    color: white;
    .text {
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      text-align: center;
      position: absolute;
      width: 100%;
      padding: 0 22px;
      a {
        color: white!important;
        text-decoration: underline;
      }
    }
  }
  &:hover .overlay {
    opacity: 1;
  }
  @media (max-width: 992px) {
    &:last-child {
      display: none;
    }
  }
`

export const CardContainer = styled.div`
  * {
    margin: 0;
    padding: 0;
  }
  ${({ theme }) =>
  `
    font-family: ${theme.font.primary};
  `}
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #FFFFFF;
  ${({ border }) =>
    border &&
  `
    border: 1px solid ${border};
  `}
  border-radius: 9px;
  min-height: 340px;
  height: 100%;
  transition: box-shadow 300ms ease;

  .text-link {
    ${({ theme }) =>
    `
      padding-top: 12px;
      color: ${theme.colors.primary};
      font-weight: bold !important;
    `}
  }

  .card--read-time {
    font-size: 12px;
    color: #222222;
  }
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .gatsby-image-wrapper {
    border-radius: 6px;
  }
  img {
    height: 200px;
    width: 100%;
    object-fit: cover;
    border-radius: 6px;
    margin-bottom: 16px;
  }
`